import React from 'react'

import { SmallText } from '../../../../packages/kiti/components/presentation/Text'
import Separator from '../../../../components/helpers/Separator'

const ReplyParentName = ({ parentName }) => {
  if (!parentName) return false

  return (
    <SmallText size="xsmall" color="dark2">
      {parentName}
    </SmallText>
  )
}

export default ReplyParentName
